
import DatePeriod from "@/components/DatePeriod.vue";
import WalletTransactionDetail from "@/components/modal/WalletTransactionDetail.vue";
import WalletTransactionMember from "@/components/modal/WalletTransactionMember.vue";
import Pagination from "@/components/Pagination.vue";
import PaginationInterface from "@/interface/Pagination";
import MainLayout from "@/layouts/MainLayout.vue";
import {
  dateToUnits,
  formatMoney,
  logout,
  number_color,
  userStatusVariant,
} from "@/plugins/GlobalFunctions";
import axios from "axios";
import Vue from "vue";
import DatePicker from "vue2-datepicker";

declare interface PaginateData {
  limit: number;
  page: number;
  total: number;
}
declare interface QueryData {
  dateRange: Array<Date>;
  search: string;
  page: number;
  from: number;
  limit: number;
}
declare interface MainData {
  busy: boolean;
  query: QueryData;
  breadcrumbs:
    | Array<{
        key: string;
        name: string;
      }>
    | [];
  items:
    | Array<{
        down_deposit: number;
        down_total: number;
        down_withdraw: number;
        first_name: string;
        last_name: string;
        up_deposit: number;
        up_total: number;
        up_withdraw: number;
        user_id: string;
        user_type: string;
        username: string;
      }>
    | [];
  paginate: PaginateData | null;
}

export default Vue.extend({
  name: "WalletTransactionView",
  components: {
    MainLayout,
    DatePeriod,
    Pagination,
    DatePicker,
    WalletTransactionDetail,
    WalletTransactionMember,
  },
  data(): MainData {
    return {
      busy: false,
      query: {
        dateRange: [],
        search: "",
        page: 1,
        from: 0,
        limit: 10,
      },
      breadcrumbs: [],
      items: [],
      paginate: null,
    };
  },
  mounted() {
    this.setDateRange();
  },
  methods: {
    setNewDateRange(newDateRange: Array<Date>) {
      this.query.dateRange = newDateRange;
      this.getWalletTransactionLists(null);
    },
    setDateRange() {
      let start_date = [0, 0, 0];
      let end_date = [23, 59, 59];
      var curr = new Date();
      var firstday = new Date(
        curr.getFullYear(),
        curr.getMonth(),
        curr.getDate(),
        ...start_date
      );
      var lastday = new Date(
        curr.getFullYear(),
        curr.getMonth(),
        curr.getDate(),
        ...end_date
      );
      this.query.dateRange = [firstday, lastday];
      this.getWalletTransactionLists(null);
    },
    async getWalletTransactionLists(payload: PaginationInterface | null) {
      if (payload && Object.keys(payload).length > 0) {
        this.query.page = payload && payload.page;
        this.query.limit = payload && payload.limit;
      }
      this.busy = true;
      await axios
        .get("/api/wallet/transaction/sum-byuserv2", {
          headers: this.$store.state.headers,
          params: {
            search: this.query.search,
            from: (this.query.page - 1) * this.query.limit,
            size: this.query.limit,
            start_date: dateToUnits(this.query.dateRange[0]),
            end_date: dateToUnits(this.query.dateRange[1]),
            wallet_id: 1001,
          },
        })
        .then((resp) => {
          this.items = resp.data.data.list || [];
          this.breadcrumbs = resp.data.data.user_list || [];
          this.paginate =
            {
              limit: resp.data.paginate.size || this.query.limit,
              page: resp.data.paginate.page || this.query.page,
              total: resp.data.paginate.total || 0,
            } || null;
        })
        .catch((error) => {
          this.$store.dispatch("swal", error);
        })
        .finally(() => {
          this.busy = false;
        });
    },
    showWalletTransactionDetail(username: string, dateRange: Array<Date>) {
      this.$root.$emit(
        "modal-wallet-transaction-detail-show",
        username,
        dateRange
      );
    },
    showWalletTransactionMember(username: string, dateRange: Array<Date>) {
      this.$root.$emit(
        "modal-wallet-transaction-member-show",
        username,
        dateRange
      );
    },

    formatMoney,
    userStatusVariant,
    dateToUnits,
    number_color,
    logout,
  },
});
